import { ComponentPropsWithoutRef } from 'react'

import { isDevelopment } from '@/utils/isDevelopment'

import { Button } from '@/components/Button'
import { Warning } from '@/components/Warning'

import { ResolvedField } from '../../../../lib/contentful/utils'

type ButtonProps = ComponentPropsWithoutRef<typeof Button>

type Props = {
	className?: string
	urlField: ResolvedField
	textField: ResolvedField
	openInNewTab?: boolean
	uppercase?: boolean
	variant?: ButtonProps['variant']
	size?: ButtonProps['size']
	color?: ButtonProps['color']
	showIcon?: boolean
}

export function ContentfulButton({
	className,
	urlField,
	textField,
	variant,
	size,
	color,
	openInNewTab,
	uppercase,
	showIcon
}: Props) {
	if ('error' in urlField) {
		if (isDevelopment()) return <Warning className={className}>{urlField.error}</Warning>
		return null
	}
	if (typeof urlField.data !== 'string' && urlField.data != null) {
		if (isDevelopment()) return <Warning className={className}>URL is not a string.</Warning>
		return null
	}
	if ('error' in textField) {
		if (isDevelopment()) return <Warning className={className}>{textField.error}</Warning>
		return null
	}
	if (typeof textField.data !== 'string' && textField.data != null) {
		if (isDevelopment()) return <Warning className={className}>Text is not a string.</Warning>
		return null
	}

	const displayText = uppercase ? textField.data?.toUpperCase() : textField.data
	return (
		<Button
			className={className}
			size={size}
			variant={variant}
			color={color}
			link={{ href: urlField.data ?? '#', target: openInNewTab ? '_blank' : '_self' }}
			showIcon={showIcon}
		>
			{displayText ?? 'Title not found'}
		</Button>
	)
}
